<script setup>
import { defineProps, ref } from "vue";

const props = defineProps({
    logoType: {
        type: String,
        required: true,
        validator: (value) => ["default", "login"].includes(value),
    },
    width: {
        type: String,
        default: "36",
    },
    customClasses: {
        type: String,
        default: "",
    },
});

const customWidth = ref(props.width);
</script>

<template>
    <div
        class="mx-auto block max-w-full"
        :class="[customClasses, `w-${customWidth}`]"
    >
        <img
            v-if="logoType === 'default'"
            src="/images/svg/loop-logo.svg"
            alt="Loop Logo"
        />
        <img
            v-else-if="logoType === 'login'"
            src="/images/svg/loop-logo-login-page.svg"
            alt="Loop Logo Login Page"
        />
    </div>
</template>
